module.exports = __webpack_public_path__ + "img/gallery1.603fc22e.webp";